var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceforceIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L0 20L7 16.0061L14 20L7 0ZM1.44929 18.3269L6.45389 3.98852L4.80016 14.4091L2.24745 17.3748L5.33087 14.787L6.4889 15.4453L1.44929 18.3269ZM7 14.4799L6.66253 13.3569L5.4835 13.0338L6.66253 12.7106L7 11.589L7.33747 12.7106L8.5165 13.0338L7.33747 13.3569L7 14.4799ZM8.66773 14.787L11.7526 17.3748L9.19984 14.4091L7.54611 3.98852L12.5521 18.3269L7.5111 15.4453L8.66773 14.787Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceforceIconBlack);
export default __webpack_public_path__ + "static/media/spaceforce-icon-black.a835c3fd9c027a18763f506a87d85ba0.svg";
export { ForwardRef as ReactComponent };